import * as React from 'react';

import { translate } from '~l10n/client';
import { IconCopyTo } from '~shared/components/icons/standard';
import { useWorkspaceActionPermissions } from '~teacher/hook/workspaces/settings';

import { WorkspaceRole } from '../../../../../api/workspaces/getWorkspaceMembers';
import { WorkspaceQuiz } from '../../../../../api/workspaces/quiz/types';

export function useCopyToAction(workspaceId: string) {
  const { canCopyToLibrary, permissions, roleQuery } =
    useWorkspaceActionPermissions({ workspaceId });
  // handler for copying to workspace
  const [isCopyQuizDialogOpen, setIsCopyQuizDialogOpen] = React.useState(false);
  const [quizIdsToCopy, setQuizIdsToCopy] = React.useState<string[]>([]);

  const copyToAction = React.useMemo(
    () => ({
      key: 'copy-to',
      title: translate('Copy To Shared Library'),
      icon: <IconCopyTo />,
      action: ({ data, close }) => {
        setIsCopyQuizDialogOpen(true);
        const workspaceQuizIds = data.map(
          (workspaceQuiz: WorkspaceQuiz) => workspaceQuiz.id
        );
        setQuizIdsToCopy(workspaceQuizIds);
        close();
      },
      disabled: () => !canCopyToLibrary,
      constraint: ({ data }) => {
        if (roleQuery.data === WorkspaceRole.Viewer) return false;

        return data.every((item) => item.type === 'quiz');
      },
      showProBadge: !permissions.copyToAnotherWorkspace,
    }),
    [canCopyToLibrary, permissions.copyToAnotherWorkspace, roleQuery.data]
  );
  return {
    isCopyQuizDialogOpen,
    setIsCopyQuizDialogOpen,
    quizIdsToCopy,
    copyToAction,
  };
}
